interface PlayModalProps {
  title: string;
  cover: string;
  duration: string;
  onClose: () => void;
}

export default function PlayModal({ title, cover, duration, onClose }: PlayModalProps) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-background-950/80 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-2xl rounded-lg overflow-hidden bg-background-100 border border-background-200 animate-fade-up">
        <div className="relative w-full aspect-video bg-background-950">
          <img
            src={cover}
            alt={`${title} 播放画面`}
            className="w-full h-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <span className="w-16 h-16 rounded-full bg-primary-500/20 text-primary-400 flex items-center justify-center mb-4">
              <i className="ri-play-circle-fill text-4xl"></i>
            </span>
            <h3 className="font-heading font-bold text-lg md:text-xl text-background-50">
              功能演示，暂无真实视频播放
            </h3>
            <p className="mt-3 text-sm text-foreground-600 max-w-md leading-6">
              本站为演示站点，播放区域仅用于展示界面与交互效果，不接入任何真实视频流、下载或资源分发服务。
              完整影片请前往正规授权平台观看。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-movie-line"></i>
              {title}
              <span className="text-foreground-400">·</span>
              <i className="ri-time-line"></i>
              {duration}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between px-5 py-4">
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-information-line"></i>
            演示范围：UI 与交互，不含实际播放
          </span>
          <button
            type="button"
            onClick={onClose}
            className="px-4 h-9 rounded-md bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}